import { $GQL } from '@GQL/index';
import { title } from '@/lib/Filters';

export async function getAdAuctionFunnelsAsOptions() {
	const query = `
        query GetAdAuctionFunnels {
            adAuctionFunnels
        }
    `;

	const results = await $GQL.request(query);
	const networks = results.adAuctionFunnels;
	return networks.map((network: string) => {
		return {
			label: title(network),
			value: network,
		};
	});
}
